import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexColumn, FlexRow, IconButton, QueryBarItemSingle } from "@similarweb/ui-components";

import { LeftFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const Header = styled.header`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const HeaderInfo = styled(LeftFlexRow)`
    column-gap: 8px;
    padding: 1px 0;
    overflow: hidden;
`;

export const Divider = styled.div`
    height: 1px;
    width: calc(100% + 80px);
    margin-left: -40px;
    margin-right: -40px;
    background-color: ${colorsPalettes.carbon[100]};
`;

export const QueryBarItemSingleStyled = styled(QueryBarItemSingle)`
    pointer-events: none;
    margin-right: 8px;
`;

export const CampaignName = styled.span`
    ${setFontVariant("subtitle1", colorsPalettes.carbon[500])};
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding-right: 20px;
`;

export const DetailsValue = styled.span`
    width: calc(100% - 172px);
    ${setFontVariant("input2", colorsPalettes.carbon[500])};
`;

export const ExitButton = styled(IconButton)`
    margin-right: -24px;
`;

export const ContentGrid = styled(FlexRow)`
    height: 100%;
    column-gap: 48px;

    > div {
        width: 50%;
        height: 100%;
    }
`;

export const CardColumn = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    background: ${colorsPalettes.carbon[25]};
    border-radius: 6px;
    overflow: hidden;
    box-sizing: border-box;
    padding-inline: 8px;
`;

export const ScrollContainer = styled(FlexColumn)`
    height: 100%;
    overflow-y: auto;
    row-gap: 40px;
`;

export const QueryBarItemDivider = styled.div`
    height: 16px;
    width: 1px;
    background-color: ${colorsPalettes.carbon[100]};
    margin-right: 8px;
`;
